import React from "react";
import bonus from "../../components/zoning.jpeg";
import pdf from "./PHILLY_QUICK_ZONING-GUIDE.pdf";

function Zoning() {
  return (
    <div className="container">
      <div className="banner">
        <img src={bonus} alt="" />
      </div>

      <div className="container_body">
        <div className="course">
          <h1>Zoning Guide (Philadelphia)-Paulette Ahmad</h1>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={pdf}>PHILLY_QUICK_ZONING-GUIDE.pdf</a>
        </div>
      </div>
    </div>
  );
}

export default Zoning;
